//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      isShow: false,
      show: false,
      loading: false,
      isDisabled: false,
      topImg: require("../assets/top.jpg"),
      logoImg: require("../assets/logo.png"),
      typeList: ["标准展位", "特装展位"],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0,
      },
      rules: {
        supportOption: "请选择参与性质",
        exhibitionType: "请选择展位类别",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
      },
      // showListNum: [["0", "1", "2", "3", "4", "5"]],
      // sateListNum: [["0", "1", "2", "3"]],
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      
    };
  },
  async mounted() {
    this.addForm = this.$route.params;
    if(!this.addForm.id){
      this.$router.push({
          name: "info",
          // params: { id: data.data.id, cellPhone: data.data.cellPhone }
        });
    }
    if(this.addForm.supportOption === '参展'){
      this.isShow = true;
    }
  },
  methods: {
    //检查手机号
    isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    onCancel() {
      console.log("on cancel");
    },
    /**
     * 确认提交
     */
    async onConfirm() {
      this.isDisabled = true;
      const add = this.$apis.exhibition.update;
      try {
        const { data } = (await this.$axios.post(add, this.addForm)) || {};
        this.showMsg("提交成功！");
        this.$router.push({
          name: "info",
          params: this.addForm
        });
      } catch (err) {
        this.showMsg(err.data.msg);
      }
    },
    onHide() {
      console.log("on hide");
    },
    onShow() {
      console.log("on show");
    },
    /**
     * 提交报名数据
     *
     */
    async submitAdd() {
      for (let key in this.rules) {
        if (!this.addForm[key]) {
          this.showMsg(this.rules[key]);
          this.isDisabled = false;
          return;
        }
      }
      this.show = true;
    },
    /**
     * 取消修改
     */
    cancel() {
      this.$router.push({
        name: "info",
        // params: { id: data.data.id, cellPhone: data.data.cellPhone }
      });
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/edit.vue